import { render, staticRenderFns } from "./SoCourseList.vue?vue&type=template&id=6c650a88&"
import script from "./SoCourseList.vue?vue&type=script&lang=js&"
export * from "./SoCourseList.vue?vue&type=script&lang=js&"
import style0 from "./SoCourseList.vue?vue&type=style&index=0&id=6c650a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports